import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import './settings.mjs';
import { UPDATE_PRIORITY } from './const.mjs';
import { TickerListener } from './TickerListener.mjs';
import { settings } from '@pixi/settings';
var Ticker = /*#__PURE__*/function () {
  function Ticker() {
    var _this = this;
    _classCallCheck(this, Ticker);
    this.autoStart = false;
    this.deltaTime = 1;
    this.lastTime = -1;
    this.speed = 1;
    this.started = false;
    this._requestId = null;
    this._maxElapsedMS = 100;
    this._minElapsedMS = 0;
    this._protected = false;
    this._lastFrame = -1;
    this._head = new TickerListener(null, null, Infinity);
    this.deltaMS = 1 / settings.TARGET_FPMS;
    this.elapsedMS = 1 / settings.TARGET_FPMS;
    this._tick = function (time) {
      _this._requestId = null;
      if (_this.started) {
        _this.update(time);
        if (_this.started && _this._requestId === null && _this._head.next) {
          _this._requestId = requestAnimationFrame(_this._tick);
        }
      }
    };
  }
  _createClass(Ticker, [{
    key: "_requestIfNeeded",
    value: function _requestIfNeeded() {
      if (this._requestId === null && this._head.next) {
        this.lastTime = performance.now();
        this._lastFrame = this.lastTime;
        this._requestId = requestAnimationFrame(this._tick);
      }
    }
  }, {
    key: "_cancelIfNeeded",
    value: function _cancelIfNeeded() {
      if (this._requestId !== null) {
        cancelAnimationFrame(this._requestId);
        this._requestId = null;
      }
    }
  }, {
    key: "_startIfPossible",
    value: function _startIfPossible() {
      if (this.started) {
        this._requestIfNeeded();
      } else if (this.autoStart) {
        this.start();
      }
    }
  }, {
    key: "add",
    value: function add(fn, context) {
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UPDATE_PRIORITY.NORMAL;
      return this._addListener(new TickerListener(fn, context, priority));
    }
  }, {
    key: "addOnce",
    value: function addOnce(fn, context) {
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UPDATE_PRIORITY.NORMAL;
      return this._addListener(new TickerListener(fn, context, priority, true));
    }
  }, {
    key: "_addListener",
    value: function _addListener(listener) {
      var current = this._head.next;
      var previous = this._head;
      if (!current) {
        listener.connect(previous);
      } else {
        while (current) {
          if (listener.priority > current.priority) {
            listener.connect(previous);
            break;
          }
          previous = current;
          current = current.next;
        }
        if (!listener.previous) {
          listener.connect(previous);
        }
      }
      this._startIfPossible();
      return this;
    }
  }, {
    key: "remove",
    value: function remove(fn, context) {
      var listener = this._head.next;
      while (listener) {
        if (listener.match(fn, context)) {
          listener = listener.destroy();
        } else {
          listener = listener.next;
        }
      }
      if (!this._head.next) {
        this._cancelIfNeeded();
      }
      return this;
    }
  }, {
    key: "count",
    get: function get() {
      if (!this._head) {
        return 0;
      }
      var count = 0;
      var current = this._head;
      while (current = current.next) {
        count++;
      }
      return count;
    }
  }, {
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        this._requestIfNeeded();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.started = false;
        this._cancelIfNeeded();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this._protected) {
        this.stop();
        var listener = this._head.next;
        while (listener) {
          listener = listener.destroy(true);
        }
        this._head.destroy();
        this._head = null;
      }
    }
  }, {
    key: "update",
    value: function update() {
      var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      var elapsedMS;
      if (currentTime > this.lastTime) {
        elapsedMS = this.elapsedMS = currentTime - this.lastTime;
        if (elapsedMS > this._maxElapsedMS) {
          elapsedMS = this._maxElapsedMS;
        }
        elapsedMS *= this.speed;
        if (this._minElapsedMS) {
          var delta = currentTime - this._lastFrame | 0;
          if (delta < this._minElapsedMS) {
            return;
          }
          this._lastFrame = currentTime - delta % this._minElapsedMS;
        }
        this.deltaMS = elapsedMS;
        this.deltaTime = this.deltaMS * settings.TARGET_FPMS;
        var head = this._head;
        var listener = head.next;
        while (listener) {
          listener = listener.emit(this.deltaTime);
        }
        if (!head.next) {
          this._cancelIfNeeded();
        }
      } else {
        this.deltaTime = this.deltaMS = this.elapsedMS = 0;
      }
      this.lastTime = currentTime;
    }
  }, {
    key: "FPS",
    get: function get() {
      return 1e3 / this.elapsedMS;
    }
  }, {
    key: "minFPS",
    get: function get() {
      return 1e3 / this._maxElapsedMS;
    },
    set: function set(fps) {
      var minFPS = Math.min(this.maxFPS, fps);
      var minFPMS = Math.min(Math.max(0, minFPS) / 1e3, settings.TARGET_FPMS);
      this._maxElapsedMS = 1 / minFPMS;
    }
  }, {
    key: "maxFPS",
    get: function get() {
      if (this._minElapsedMS) {
        return Math.round(1e3 / this._minElapsedMS);
      }
      return 0;
    },
    set: function set(fps) {
      if (fps === 0) {
        this._minElapsedMS = 0;
      } else {
        var maxFPS = Math.max(this.minFPS, fps);
        this._minElapsedMS = 1 / (maxFPS / 1e3);
      }
    }
  }], [{
    key: "shared",
    get: function get() {
      if (!Ticker._shared) {
        var shared = Ticker._shared = new Ticker();
        shared.autoStart = true;
        shared._protected = true;
      }
      return Ticker._shared;
    }
  }, {
    key: "system",
    get: function get() {
      if (!Ticker._system) {
        var system = Ticker._system = new Ticker();
        system.autoStart = true;
        system._protected = true;
      }
      return Ticker._system;
    }
  }]);
  return Ticker;
}();
export { Ticker };